import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGlassdoorComponent } from './simple-icons-glassdoor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGlassdoorComponent ],
    exports:      [ SimpleIconsGlassdoorComponent ],
    bootstrap:    []
})
export class SimpleIconsGlassdoorModule {}
